import {
  WORKSPACES_OUTPUT_TEMPLATE_OUTPUT_LIST_ERROR,
  WORKSPACES_OUTPUT_TEMPLATE_OUTPUT_LIST_REQUEST,
  WORKSPACES_OUTPUT_TEMPLATE_OUTPUT_LIST_SUCCESS,
} from "../../Types/user/Types";

const initialState = {
  error: "",
  workspace_output_template_list_data: "",
  loader: false,
};
const workspaces_Output_Teamplate_Output_List_Reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case WORKSPACES_OUTPUT_TEMPLATE_OUTPUT_LIST_SUCCESS:
      return {
        ...initialState.workspace_output_template_list_data,
        error: "",
        workspace_Output_Teamplate_folder_create_data: action.payload,
        loader: false,
      };
    case WORKSPACES_OUTPUT_TEMPLATE_OUTPUT_LIST_ERROR:
      return {
        ...initialState.workspace_output_template_list_data,
        error: action.error,
        workspace_Output_Teamplate_folder_create_data: "",
        loader: false,
      };
    case WORKSPACES_OUTPUT_TEMPLATE_OUTPUT_LIST_REQUEST:
      return {
        ...initialState.workspace_output_template_list_data,
        error: null,
        workspace_Output_Teamplate_folder_create_data: "",
        loader: true,
      };
    default:
      return state;
  }
};

export default workspaces_Output_Teamplate_Output_List_Reducer;
